/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionreachone2Inputs */

const en_actionreachone2 = /** @type {(inputs: Actionreachone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goes to one favourite`)
};

const de_actionreachone2 = /** @type {(inputs: Actionreachone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geht an einen Favoriten`)
};

/**
* | output |
* | --- |
* | "Goes to one favourite" |
*
* @param {Actionreachone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionreachone2 = /** @type {((inputs?: Actionreachone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionreachone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionreachone2(inputs)
	return de_actionreachone2(inputs)
});
export { actionreachone2 as "actionReachOne" }